import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { DataGrid, gridPageCountSelector, gridPageSelector, useGridApiContext, useGridSelector, GridToolbar } from '@mui/x-data-grid';
import { OptionIcon } from '../Icon';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Pagination from '@mui/material/Pagination';
import LinearProgress from '@mui/material/LinearProgress';
import makeStyles from '@mui/styles/makeStyles';
import { AppBpDataGrid } from './BpDataGrid.styled';
import { DashboardTooltip } from '../OverflowTip';
import Typography from '../Typography';
const SERVER_OPTIONS = {
    useCursorPagination: true,
};
const useStyles = makeStyles({
    nothing: {},
    gridReverse: {},
    parent: {
        position: "relative",
        width: '100%',
        height: '100%',
        zIndex: 5000
    },
    backdrop: {
        position: "absolute",
        backgroundColor: '#FFFFFF',
        top: 2,
        width: '100%',
        height: '100%',
        opacity: 0.6
    }
});
function customCheckbox(theme) {
    return {
        '& .MuiCheckbox-root svg': {
            width: 16,
            height: 16,
            backgroundColor: 'transparent',
            border: `1px solid ${theme.palette.mode === 'light' ? '#d9d9d9' : 'rgb(67, 67, 67)'}`,
            borderRadius: 2,
        },
        '& .MuiCheckbox-root svg path': {
            display: 'none',
        },
        '& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg': {
            backgroundColor: '#1890ff',
            borderColor: '#1890ff',
        },
        '& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after': {
            position: 'absolute',
            display: 'table',
            border: '2px solid #fff',
            borderTop: 0,
            borderLeft: 0,
            transform: 'rotate(45deg) translate(-50%,-50%)',
            opacity: 1,
            transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
            content: '""',
            top: '50%',
            left: '39%',
            width: 5.71428571,
            height: 9.14285714,
        },
        '& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after': {
            width: 8,
            height: 8,
            backgroundColor: '#1890ff',
            transform: 'none',
            top: '39%',
            border: 0,
        },
    };
}
const StyledDataGrid = styled(DataGrid)(({ theme }) => (Object.assign({ border: 0, color: theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)', fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','), WebkitFontSmoothing: 'auto', letterSpacing: 'normal', '& .MuiDataGrid-columnsContainer': {
        backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
    }, '& .MuiDataGrid-iconSeparator': {
        display: 'none',
    }, '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
        borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
    }, '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
        borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
    }, '& .MuiDataGrid-cell': {
        color: theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
        '&:focus': {
            outline: '0px'
        }
    }, '& .MuiPaginationItem-root': {
        borderRadius: 0,
    } }, customCheckbox(theme))));
const StyledFixNumberPagination = styled('div')(({ theme }) => ({}));
// if (props?.alignPagination === 'center') {
//   style['.MuiTablePagination-root'] = {
//     margin: 'auto !important'
//   }
// }
// else if (props?.alignPagination === 'left') {
//   style['.MuiDataGrid-footerContainer'] = {
//     alignContent: 'start !important',
//     display: 'table-footer-group !important'
//   }
// }
// else {
//   style['.MuiDataGrid-footerContainer'] = {
//     alignContent: 'start !important',
//     display: 'initial !important'
//   }
// }
function FixNumberPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    return (_jsx(StyledFixNumberPagination, { children: _jsx(Pagination, { color: "primary", count: pageCount, page: page + 1, onChange: (event, value) => apiRef.current.setPage(value - 1) }) }));
}
const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    '& .ant-empty-img-1': {
        fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
    },
    '& .ant-empty-img-2': {
        fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
    },
    '& .ant-empty-img-3': {
        fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
    },
    '& .ant-empty-img-4': {
        fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
    },
    '& .ant-empty-img-5': {
        fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
        fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
    },
}));
export const BpDataGrid = (props) => {
    // const [pageSize, setPageSize] = React.useState<number>(5);
    const classes = useStyles();
    let componentList = {};
    const MyMoreIcon = React.forwardRef(function MyMoreIcon(props, ref) {
        return _jsx(Box, Object.assign({ style: { paddingTop: 12, height: 30 } }, props, { ref: ref }, { children: _jsx(OptionIcon, {}) }));
    });
    function CustomMoreAction() {
        return (_jsx(DashboardTooltip, Object.assign({ title: (props === null || props === void 0 ? void 0 : props.optionTooltip) || 'More', placement: "bottom", arrow: true }, { children: _jsx(MyMoreIcon, {}) })));
    }
    function CustomLoadingOverlay() {
        return (_jsxs("div", Object.assign({ className: classes.parent }, { children: [_jsx("div", { className: classes.backdrop }), _jsx(LinearProgress, {})] })));
    }
    function CustomNoRowsOverlay() {
        if (props === null || props === void 0 ? void 0 : props.emptyIcon) {
            return (_jsxs(StyledGridOverlay, Object.assign({ style: { margin: 24, height: 'calc(100% - 24px)' } }, { children: [_jsx(Box, Object.assign({ style: { marginBottom: 16 } }, { children: props === null || props === void 0 ? void 0 : props.emptyIcon })), (props === null || props === void 0 ? void 0 : props.noRowTitle) === '' ? (_jsx(_Fragment, {})) :
                        (_jsx(Box, Object.assign({ style: { marginBottom: 8 } }, { children: _jsx(Typography, Object.assign({ variant: 'h6' }, { children: props === null || props === void 0 ? void 0 : props.noRowTitle })) }))), (props === null || props === void 0 ? void 0 : props.noRowDesc) === '' ? (_jsx(_Fragment, {})) :
                        (_jsx(Box, { children: _jsx(Typography, Object.assign({ variant: 'body1', color: 'textSecondary' }, { children: props === null || props === void 0 ? void 0 : props.noRowDesc })) }))] })));
        }
        else
            return (_jsxs(StyledGridOverlay, Object.assign({ style: { margin: 24, height: 'calc(100% - 24px)' } }, { children: [(props === null || props === void 0 ? void 0 : props.noRowTitle) === '' ? (_jsx(_Fragment, {})) :
                        (_jsx(Box, Object.assign({ style: { marginBottom: 8 } }, { children: _jsx(Typography, Object.assign({ variant: 'h6' }, { children: props === null || props === void 0 ? void 0 : props.noRowTitle })) }))), (props === null || props === void 0 ? void 0 : props.noRowDesc) === '' ? (_jsx(_Fragment, {})) :
                        (_jsx(Box, { children: _jsx(Typography, Object.assign({ variant: 'body1', color: 'textSecondary' }, { children: props === null || props === void 0 ? void 0 : props.noRowDesc })) }))] })));
    }
    let reverse = false;
    if (props === null || props === void 0 ? void 0 : props.reverse) {
        reverse = true;
    }
    if (props === null || props === void 0 ? void 0 : props.toolbar) {
        componentList['Toolbar'] = GridToolbar;
    }
    componentList['LoadingOverlay'] = CustomLoadingOverlay;
    componentList['NoRowsOverlay'] = CustomNoRowsOverlay;
    componentList['NoResultsOverlay'] = CustomNoRowsOverlay;
    let style = {};
    if (props === null || props === void 0 ? void 0 : props.optionIcon) {
        componentList['MoreActionsIcon'] = CustomMoreAction;
    }
    style['& .MuiDataGrid-columnHeader, .MuiDataGrid-cell'] = {
        padding: `0px 16px`
    };
    style['& .MuiDataGrid-cell'] = {
        outline: `0px !important`
    };
    if ((props === null || props === void 0 ? void 0 : props.separator) === false) {
        style['.MuiDataGrid-iconSeparator'] = {
            display: 'none',
        };
        style['& .MuiDataGrid-columnHeader, .MuiDataGrid-cell'] = {
            borderRight: `0px solid`,
            padding: '0px 16px'
        };
    }
    if (props === null || props === void 0 ? void 0 : props.headerColor) {
        style['.MuiDataGrid-columnHeaders'] = {
            backgroundColor: props === null || props === void 0 ? void 0 : props.headerColor
        };
    }
    if (props === null || props === void 0 ? void 0 : props.toolbarColor) {
        style['.MuiDataGrid-toolbarContainer'] = {
            backgroundColor: props === null || props === void 0 ? void 0 : props.toolbarColor
        };
    }
    if (props === null || props === void 0 ? void 0 : props.textHeaderColor) {
        style['.MuiDataGrid-columnHeaderTitle'] = {
            color: props === null || props === void 0 ? void 0 : props.textHeaderColor
        };
    }
    let pagingTopOffset = -89;
    if (props === null || props === void 0 ? void 0 : props.pagingTopOffset) {
        pagingTopOffset = props === null || props === void 0 ? void 0 : props.pagingTopOffset;
    }
    style['.MuiTablePagination-toolbar'] = {
        height: '40px !important',
        minHeight: '40px !important',
        paddingRight: '0px !important'
    };
    if ((props === null || props === void 0 ? void 0 : props.alignPagination) === 'center') {
        if ((props === null || props === void 0 ? void 0 : props.paginationType) === 'fixNumber') {
            if (reverse) {
                style['.MuiDataGrid-footerContainer'] = {
                    display: 'table',
                    margin: 'auto',
                    borderTop: '0px',
                    padding: '8px',
                    height: '40px !important',
                    minHeight: '40px !important', marginBottom: '-16px',
                    position: 'absolute',
                    top: pagingTopOffset,
                    right: "40%"
                };
            }
            else {
                style['.MuiDataGrid-footerContainer'] = {
                    display: 'table',
                    margin: 'auto',
                    marginBottom: '-8px',
                    borderTop: '0px !important',
                    // marginTop: '20px !important',
                    padding: '8px',
                    height: '40px !important',
                    minHeight: '40px !important', position: 'absolute',
                    right: "40%"
                };
            }
        }
        else {
            if (reverse) {
                style['.MuiTablePagination-root'] = {
                    margin: 'auto !important',
                    borderTop: '0px !important',
                    height: 40
                };
                style['.MuiDataGrid-footerContainer'] = {
                    borderTop: '0px',
                    position: 'absolute',
                    top: pagingTopOffset,
                    padding: '8px',
                    height: '40px !important',
                    minHeight: '40px !important', right: "40%"
                };
            }
            else {
                style['.MuiTablePagination-root'] = {
                    margin: 'auto !important',
                    height: 40
                };
                style['.MuiDataGrid-footerContainer'] = {
                    borderTop: '0px !important',
                    padding: '8px',
                    height: '40px !important',
                    minHeight: '40px !important',
                    position: 'absolute',
                    right: "40%"
                };
            }
        }
    }
    else if ((props === null || props === void 0 ? void 0 : props.alignPagination) === 'left') {
        if (reverse) {
            style['.MuiDataGrid-footerContainer'] = {
                display: 'grid',
                borderTop: '0px',
                padding: '8px',
                height: '40px !important',
                minHeight: '40px !important', position: 'absolute',
                top: pagingTopOffset,
                left: -8
            };
        }
        else {
            style['.MuiDataGrid-footerContainer'] = {
                display: 'grid',
                borderTop: '0px !important',
                padding: '8px',
                height: '40px !important',
                minHeight: '40px !important',
                position: 'absolute',
            };
            style['.MuiPagination-root'] = {
                marginBottom: '8px'
            };
        }
    }
    else {
        if (reverse) {
            style['.MuiDataGrid-footerContainer'] = {
                borderTop: '0px',
                padding: '8px',
                height: '40px !important',
                minHeight: '40px !important', position: 'absolute',
                top: pagingTopOffset,
                right: 0
            };
        }
        else {
            style['.MuiDataGrid-footerContainer'] = {
                borderTop: '0px !important',
                padding: '8px',
                height: '40px !important',
                minHeight: '40px !important',
                position: 'absolute',
                right: "0px"
            };
        }
    }
    if ((props === null || props === void 0 ? void 0 : props.alignToolBar) === 'center') {
        style['.MuiDataGrid-toolbarContainer'] = {
            textAlign: 'center',
            display: 'block'
        };
    }
    else if ((props === null || props === void 0 ? void 0 : props.alignToolBar) === 'right') {
        style['.MuiDataGrid-toolbarContainer'] = {
            textAlign: 'end',
            display: 'block'
        };
    }
    else {
        style['.MuiDataGrid-toolbarContainer'] = {
            textAlign: 'start',
            display: 'block'
        };
    }
    if ((props === null || props === void 0 ? void 0 : props.paginationType) === 'fixNumber') {
        componentList['Pagination'] = FixNumberPagination;
    }
    if ((props === null || props === void 0 ? void 0 : props.rows) && (props === null || props === void 0 ? void 0 : props.rows.length) <= 0) {
        style['border'] = 0;
    }
    else {
        style['border'] = '1px solid rgba(224, 224, 224, 1)';
    }
    return (_jsx(AppBpDataGrid, { children: _jsx("div", Object.assign({ style: { height: (props === null || props === void 0 ? void 0 : props.height) || 500 + ((props === null || props === void 0 ? void 0 : props.reverse) || (props === null || props === void 0 ? void 0 : props.hideFooter) || false ? 0 : 56) } }, { children: _jsx("div", Object.assign({ style: { height: (props === null || props === void 0 ? void 0 : props.height) || 500, width: '100%' } }, { children: (props === null || props === void 0 ? void 0 : props.serverPaginationMode) ? (_jsx(_Fragment, { children: "serverPaginationMode developing..." })) : (_jsx(DataGrid, Object.assign({}, props, { className: reverse ? classes.gridReverse : classes.nothing, 
                    // rows={!props.loading ? props?.rows || dataTest : []} //API response
                    rows: (props === null || props === void 0 ? void 0 : props.rows) || [], sx: style, 
                    // style for popper -> render outside of the grid
                    componentsProps: {
                        basePopper: {
                            sx: {
                                "& .MuiDataGrid-menuList": {
                                    padding: "8px",
                                    boxShadow: '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)'
                                },
                                '& .MuiMenuItem-root': {
                                    padding: "10px 16px",
                                    height: 40,
                                    borderRadius: '4px',
                                    '&:hover': {
                                        backgroundColor: '#F2F2F2',
                                    },
                                },
                            }
                        }
                    }, components: componentList, hideFooterSelectedRowCount: true, 
                    // pageSize={pageSize}
                    // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions: [5, 10, 20], pagination: true, initialState: props.initialState }))) })) })) }));
};
export default BpDataGrid;
